import Layout from 'components/Layout'
import RocketPlaceholder from 'components/RocketPlaceholder'

import { getMenuManagerPosAccountsLink } from 'utils/general/links'

const PosAccountsNotification = () => {
  const rocketPlaceholderLabel = (
    <span>
      POS Accounts have been moved to{' '}
      <a href={getMenuManagerPosAccountsLink()} className="-color-primary">
        Settings &gt; POS Accounts
      </a>{' '}
      in preparation for future updates.
    </span>
  )

  return <Layout mainContent={<RocketPlaceholder label={rocketPlaceholderLabel} />} />
}

export default PosAccountsNotification
